import gql from "graphql-tag";

const getVendorRedeemPaused = (schema) => gql`query getVendorRedeemPaused {
    ${schema}_bll_redemption_vendor__c {
        id
        sfid
        name
        bll_active__c
        bll_change_reason__c
        bll_redemption_type__c
    }
  }`;

export default getVendorRedeemPaused;
